/**
 * 
 * 부트스트랩 리팩토링 시 삭제해야 할 파일(순서가 바뀌면 안되어 경로, 파일명만 기재)
 * import './assets/scss/common-css.scss';
 * import bootstrap from 'bootstrap/dist/js/bootstrap';
 * 
 */

import './assets/scss/common-css.scss';
import './assets/scss/SideNavList.scss'
import './assets/scss/hospitalInfo.scss'
import './assets/scss/common.scss'
import './assets/scss/ant-design.scss'
import './assets/scss/ant-design-custom.scss'
import './assets/scss/sidenavbar.scss'
import './assets/scss/dashboard.scss'
import './assets/scss/addItem.scss'
import './assets/scss/modal.scss'
import './assets/scss/table.scss'
import './assets/scss/pagination.scss'
import './assets/scss/add-hospital.scss'
import './assets/scss/vue-datepicker.scss'
import './assets/scss/search-filter.scss'
import './assets/scss/custom-antdv.scss'
import bootstrap from 'bootstrap/dist/js/bootstrap';

/**
 * 부트스트랩 리팩토링 시 추가된/할 파일
 * import './assets/scss/new-common.scss'
 */
import './assets/scss/new-common.scss'

/**
 * 모바일 안전망. 여러 화면에 공통으로 걸리는 것만 모아 둔 파일이다.
 * 내용이 전부 @media(max-width:767px) 안에 있어 PC 렌더에는 영향이 없다.
 * 뒤에 오는 규칙이 이기도록 마지막에 둔다.
 */
import './assets/scss/mobile-safety.scss'

export default {
  install() {},
};
